import { useParams } from "react-router";

export function useUnsafeParams<
  T extends string | Record<string, string | undefined>
>() {
  return useParams<T>() as unknown as T;
}
